import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { getAuthToken } from "./cognitoConfig";

import { HomePage } from "./Pages/HomePage";
import DisplayQuoteTool from"./Components/QuoteTool/QuoteTool"
import LoginPage from "./Pages/LoginPage";
import "./App.css";
import SignUpPage from "./Pages/SignUpPage";
import Loader from "./utils/loader/Loader";
import { useSelector } from "react-redux";
import { RootState } from "./redux/store/store";
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from "react-notifications";
import ConfirmSignupPage from "./Pages/ConfirmSignupPage";
import GenerateQuotePage from "./Components/GenerateQuote/GenerateQuote";
import ForgotPassword from "./Pages/ForgotPassword";


const LoginRoute = ({ children }) => {
  const authToken = getAuthToken();
  if (authToken) {
    return <Navigate to="/home" />;
  }
  return children;
};

const ProtectedRoute = ({ children }) => {
  const authToken = getAuthToken();
  if (!authToken) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  const loaderState = useSelector((state: RootState) => state.loader);
  return (
    <div>
      {/* Notification pop container */}
      <ToastContainer />
      {/* Loader Container */}
      <Loader visible={loaderState?.loaderVisibleState} />
      <BrowserRouter>
  <Routes>
    <Route path="*" element={<Navigate to="/login" replace />} />

    
    <Route
      path="/login"
      element={
        <LoginRoute>
          <LoginPage />
        </LoginRoute>
      }
    />

    <Route
      path="/signup"
      element={<SignUpPage />}
    />

    <Route
      path="/confirm-signup"
      element={<ConfirmSignupPage />}
    />

    <Route
      path="/forgot-password"
      element={<ForgotPassword />}
    />


    <Route
      path="/home"
      element={
        <ProtectedRoute>
          <HomePage />
        </ProtectedRoute>
      }
    />

    <Route
      path="/quoteTool"
      element={
        <ProtectedRoute>
          <DisplayQuoteTool />
        </ProtectedRoute>
      }
    />

    <Route
      path="/generate-quote/:partId"
      element={
        <ProtectedRoute>
          <GenerateQuotePage />
        </ProtectedRoute>
      }
    />
  </Routes>
</BrowserRouter>
<NotificationContainer />
    </div>
  );
}

export default App;